export const messages = {
  title: {
    id: 'admin/promotions.form.more-for-less.editor.benefit.advanced-config.title',
  },
  description: {
    id: 'admin/promotions.form.more-for-less.editor.benefit.advanced-config.description',
  },
  equals: {
    group: {
      id: 'admin/promotions.form.more-for-less.editor.benefit.advanced-config.equals.title',
    },
    radio: {
      id: 'admin/promotions.form.more-for-less.view.benefit.advanced-config.equals',
    },
  },
  mostExpensive: {
    group: {
      id: 'admin/promotions.form.more-for-less.editor.benefit.advanced-config.most-expensive.title',
    },
    radio: {
      id: 'admin/promotions.form.more-for-less.view.benefit.advanced-config.most-expensive',
    },
  },
  distributed: {
    group: {
      id: 'admin/promotions.form.more-for-less.editor.benefit.advanced-config.distributed.title',
    },
    radio: {
      id: 'admin/promotions.form.more-for-less.editor.benefit.advanced-config.distributed',
    },
    placeholder: {
      id: 'admin/promotions.form.more-for-less.editor.benefit.advanced-config.distributed.placeholder',
    },
    description: {
      id: 'admin/promotions.form.more-for-less.editor.benefit.advanced-config.distributed.description',
    },
    quantityPlaceholder: {
      id: 'admin/promotions.form.more-for-less.quantity.placeholder',
    },
  },
}
